import { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../controls/Button';

const CONNECT_METHODS = [
  {
    id: 1,
    name: 'Wi-Fi',
    description: 'Set up your device wirelessly for a flexible and convenient connection.',
    buttonName: 'Download WiFi Setup Guide',
    image: '/images/onboarding/wifi.png'
  },
  {
    id: 2,
    name: 'Ethernet',
    description: 'Ensure a stable, high-speed connection by using a wired Ethernet connection.',
    buttonName: 'Download Ethernet Setup Guide',
    image: '/images/onboarding/ethernet.png'
  },
  {
    id: 3,
    name: 'Cellular',
    description: 'Easily connect via a cellular network when WiFi or Ethernet isn’t an option.',
    buttonName: 'Download Cellular Setup Guide',
    image: '/images/onboarding/cellular.png'
  }
];

/**
 * Header component.
 * @returns - React element that represents the Header component.
 */
function Header(): ReactElement {
  return (
    <div className="flex flex-col items-center">
      <div className="text-white text-2xl font-bold">
        <span className="text-primary-500">Step 2:</span> Connect all devices to internet
      </div>
      <div className="text-gray-400 mt-1">
        There are 3 ways the devices can be connected to internet
      </div>
    </div>
  );
}

/**
 * AddDevice component.
 * @returns - React element that represents the AddDevice component.
 */
export default function OnboardingConnectInternet(): ReactElement {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col flex-1 items-center justify-between w-full relative">
      <button
        type="button"
        className="material-icons-outlined text-md cursor-pointer absolute top-0 left-0 text-white"
        onClick={() => navigate(-1)}
      >
        chevron_left
      </button>
      <Header />
      <div className="mt-12 flex flex-col justify-center items-center">
        <div className="flex gap-5">
          {CONNECT_METHODS.map((method) => (
            <div
              key={method.id}
              className="flex flex-col items-center py-5 px-4 bg-[rgba(255,255,255,0.1)] rounded-lg max-w-[20rem]"
            >
              <div className="w-[17.938rem] h-[15.938rem] rounded-lg bg-container-300" />
              <div className="text-white text-xl font-semibold mt-4 text-center">{method.name}</div>
              <div className="text-gray-400 mt-1 text-center">{method.description}</div>
              <Button
                name={method.buttonName}
                theme="secondary-color"
                size="sm"
                className="mt-4"
                onClick={() => {}}
              />
            </div>
          ))}
        </div>
      </div>
      <div className="flex flex-col items-center">
        <div className="mt-3">
          <Button
            onClick={() => {
              navigate('/onboarding/configure-devices');
            }}
            name="I have done this step"
            theme="primary"
            size="sm"
          />
        </div>
        <div className="mt-5 text-gray-400">
          Facing trouble?{' '}
          <button className="text-primary-500" type="button" onClick={() => {}}>
            Contact Us
          </button>
        </div>
      </div>
    </div>
  );
}
